import { render, staticRenderFns } from "./OrRefunDetail.vue?vue&type=template&id=3c300bf2&scoped=true"
import script from "./OrRefunDetail.vue?vue&type=script&lang=js"
export * from "./OrRefunDetail.vue?vue&type=script&lang=js"
import style0 from "./OrRefunDetail.vue?vue&type=style&index=0&id=3c300bf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c300bf2",
  null
  
)

export default component.exports